export type Service = {
    id: number | string | null;
    code?: string;
    name: string;
    category?: string;
    price: string;
    costType: string;
    notes?: string;
    void?: "yes" | "no";
    voidReason?: string;
    validateReason?: string;
    creatorId?: string;
    creatorName?: string;
    createdAt?: string;
    updaterId?: string;
    updaterName?: string;
    updatedAt?: string;
};

export const defaultService: Service = {
    id: "",
    code: "",
    name: "",
    category: "",
    price: "",
    costType: "",
    notes: "",
    void: "no",
    voidReason: "",
    validateReason: "",
    creatorId: "",
    creatorName: "",
    createdAt: "",
    updaterId: "",
    updaterName: "",
    updatedAt: "",
};
